import styled from 'styled-components'
import Link from 'next/link'
import { SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'
import { MdOutlineCheck } from 'react-icons/md'

const PortfolioProgressStyled = styled.div`
  .portfolio-title {
    display: flex;
    justify-content: space-between;
  }
  .portfolio-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .portfolio-item {
    font: var(--p2Regular);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .progress {
    font: var(--regularBold);
    color: var(--turquoise);
  }
`

function PortfolioProgress({
  curriculum, testimonies, social_media, projects,
}) {
  const hasProjects = projects >= 4
  const all = [curriculum, testimonies, social_media, hasProjects]
  const progress = all.filter(Boolean).length

  const checkColor = (value) => (value ? '#51B887' : 'var(--neutral40)')

  if (progress === all.length) return null

  return (
    <PortfolioProgressStyled className="progress-item">
      <div className="portfolio-title">
        <Typography font="regularBold">
            Portafolio
        </Typography>
        <span className="progress">
          {(progress * 100) / 4}
          %
        </span>
      </div>
      <ul className="portfolio-list">
        <li className="portfolio-item">
          Redes Sociales
          <MdOutlineCheck size={24} color={checkColor(social_media)} />
        </li>
        <li className="portfolio-item">
          Testimonios
          <MdOutlineCheck size={24} color={checkColor(testimonies)} />
        </li>
        <li className="portfolio-item">
          Curriculum
          <MdOutlineCheck size={24} color={checkColor(curriculum)} />
        </li>
        <li className="portfolio-item">
          {projects <= 4 ? `${projects || 0} de 4 proyectos` : `${projects} proyectos`}
          <MdOutlineCheck size={24} color={checkColor(hasProjects)} />
        </li>
      </ul>
      <Link href="/estudiante/portafolio" passHref>
        <SecondaryButton fullWidth>
          Ver portafolio
        </SecondaryButton>
      </Link>
    </PortfolioProgressStyled>
  )
}

export default PortfolioProgress
